// Time in seconds
export const USER_TIME_ACTIVITY = {
	IDLE: 600,
	TIMEOUT: 120,
	PING: 10
};
